/* Каталоги по языкам.
 *
 * На язык — два файла: content.<lang>.js (учебный текст модулей и сцен) и
 * ui.<lang>.js (подписи интерфейса). Оба правятся руками; генератора в
 * репозитории нет, источник истины — эти файлы (см. шапки content/ui.*.js).
 *
 * Добавить язык = добавить сюда два импорта и строку в LANGS (src/i18n).
 * Полнота каталогов проверяется scripts/check_catalogs.mjs.
 */
import { content_en } from './content.en';
import { content_ru } from './content.ru';
import { content_bg } from './content.bg';
import { content_uk } from './content.uk';
import { ui_en } from './ui.en';
import { ui_ru } from './ui.ru';
import { ui_bg } from './ui.bg';
import { ui_uk } from './ui.uk';

export const CATALOGS = {
  en: { ...content_en, ...ui_en },
  ru: { ...content_ru, ...ui_ru },
  bg: { ...content_bg, ...ui_bg },
  uk: { ...content_uk, ...ui_uk },
};
